module.exports = __webpack_public_path__ + "static/media/thumb.eded9212.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumb.jpg
// module id = 813
// module chunks = 0